import Button, { ButtonType } from '@/components/Button';
import DictTable from '@/components/DictTable';
import Modal, { IModalProps } from '@/components/Modal';
import useCurrentUser from '@/hooks/useCurrentUser';
import { ParentAccountStatus, ParentAccountStatusToText } from '@/lib/Account/types';
import { Dialog } from '@headlessui/react';
import { Icon24Cancel } from '@vkontakte/icons';
import clsx from 'clsx';

interface IParentModalProps extends IModalProps {}

export default function ParentModal({ open, closeModal }: IParentModalProps) {
  const { data: user } = useCurrentUser();

  return (
    // @ts-ignore - TypeScript compatibility issue with React 18 types
    <Modal open={open} closeModal={closeModal}>
      {/* @ts-ignore - TypeScript compatibility issue with React 18 and HeadlessUI */}
      <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-linear-dark px-9 py-2 text-left align-middle shadow-xl transition-all h-full">
        {/* @ts-ignore - TypeScript compatibility issue with React 18 types */}
        <div className="flex flex-col justify-between h-full">
          <div>
            <Button
              type={ButtonType.Link}
              className="absolute w-6 h-6 top-9 right-9 text-icon-inverse z-50"
              onClick={closeModal}
              buttonType="button"
            >
              <Icon24Cancel className="w-full h-full" />
            </Button>
          </div>
          <div className="flex flex-col justify-center items-center mt-8 h-full">
            <h2 className="text-center text-primary px-16">
              {user?.account?.sponsorName || `${user?.parent?.firstName} ${user?.parent?.lastName}`}
            </h2>
            <h4 className="text-center text-secondary mt-1 mb-8">{user?.parent?.phoneNumber}</h4>
            <DictTable
              columns={[
                [
                  {
                    key: 'Status',
                    value: (
                      <h4
                        className={clsx('font-medium', {
                          'text-u-positive': user?.parent?.status === ParentAccountStatus.APPROVED,
                        })}
                      >
                        {ParentAccountStatusToText[user?.parent?.status as string]}
                      </h4>
                    ),
                  },
                  {
                    key: 'Name',
                    value: `${user?.parent?.firstName} ${user?.parent?.lastName}`,
                  },
                ],
              ]}
            />
          </div>
        </div>
      </Dialog.Panel>
    </Modal>
  );
}
